import styled from "styled-components";
import {JACKPOT_WIDGET_LAYOUT} from "../../jackpot-widget.component";

export interface IJackpotWidgetAspectRatioBoxProps {
    layout: JACKPOT_WIDGET_LAYOUT;
};

const handlePaddingTop = (layout: JACKPOT_WIDGET_LAYOUT) => {
    switch (layout) {
        case JACKPOT_WIDGET_LAYOUT.LANDSCAPE:
            return "58%";
        case JACKPOT_WIDGET_LAYOUT.LANDSCAPE_WIDE:
            return "25%";
        case JACKPOT_WIDGET_LAYOUT.PORTRAIT:
        default:
            return "123%";
    }
};

export const JackpotWidgetAspectRatioBox = styled.div<IJackpotWidgetAspectRatioBoxProps>`
    position: relative;
    padding-top: ${({layout}) => handlePaddingTop(layout)};
    transition: padding-top 0.5s ease-in-out;
`;
